<template>
  <div id="galleryBlock">
    <div class="container">
      <!--<h1>{{$t("gallery.gallery")}}</h1>-->
      <carousel mouseDrag :per-page="1" autoplay :autoplayTimeout="2500" loop >
        <slide>
          <img src="https://atelier-sud.fr/galerie/CerfGM.jpg" alt="Gallerie" />
        </slide>
        <slide>
          <img src="https://atelier-sud.fr/galerie/Saintes.jpg" alt="Gallerie" />
        </slide>
        <slide>
          <img src="https://atelier-sud.fr/galerie/LyceeGFGM.jpg" alt="Gallerie" />
        </slide>
        <slide>
          <img src="https://atelier-sud.fr/galerie/SeaquariumGM.jpg" alt="Gallerie" />
        </slide>
        <slide>
          <img src="https://atelier-sud.fr/galerie/SchweppesGolfGM.jpg" alt="Gallerie" />
        </slide>
        <slide>
          <img src="https://atelier-sud.fr/galerie/LionGM.jpg" alt="Gallerie" />
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  data: function() {
    return {
      images: [
        { image: "https://atelier-sud.fr/galerie/CerfGM.jpg" },
        { image: "https://atelier-sud.fr/galerie/Saintes.jpg" },
        { image: "https://atelier-sud.fr/galerie/LyceeGFGM.jpg" },
        { image: "https://atelier-sud.fr/galerie/SeaquariumGM.jpg" },
        { image: "https://atelier-sud.fr/galerie/SchweppesGolfGM.jpg" },
        { image: "https://atelier-sud.fr/galerie/LionGM.jpg" }
      ]
    };
  },
  components: {
    Carousel,
    Slide
  }
};
</script>

<style scoped>
#galleryBlock {
  min-height: 400px;
  padding: 50px 0 50px 0;
}

h1 {
  font-family: "Neue Montreal", sans-serif;
  font-weight: 600;
  padding: 0 0 20px 0;
}

@media screen and (max-width: 600px){
  img{
    width: 200px;
  }
  #galleryBlock {
    min-height: 300px;
  }
}

.container {
  text-align: center;
}
</style>
